import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import LandingHeader from "@/components/LandingHeader";

/**
 * Service landing pages: single conversion focus (Tron branding | Home | tracked Call Now).
 * No service navigation, so paid + organic service traffic has one next step.
 * City/location pages, blog, legal and informational pages keep the full site header.
 */
export const LANDING_ROUTES = [
  // Residential
  "/residential/panel-upgrades",
  "/residential/fuse-box-conversions",
  "/residential/pot-lights-led-lighting",
  "/residential/ceiling-bathroom-fans-gfci",
  "/residential/knob-tube-wiring",
  "/residential/surge-protection-alarms",
  "/residential/hot-tub-pool-connections",
  "/residential/landscape-outdoor-lighting",
  "/residential/camera-systems",
  "/residential/motion-security-lighting",
  // Lutron Home
  "/smart-home/lutron-homeworks",
  "/smart-home/radiora-2",
  "/smart-home/radiora-3",
  "/smart-home/palladiom-shades",
  "/smart-home/smart-panels-occupancy",
  "/smart-home/voice-control",
  "/smart-home/smart-thermostats",
  // EV & energy
  "/ev-energy/charger-installation",
  "/ev-energy/generator-wiring",
  "/ev-energy/energy-management",
  // Commercial
  "/commercial/office-retail-restaurant",
  "/commercial/panel-lighting-upgrades",
  "/commercial/transformers-subpanels",
  "/commercial/exit-security-lighting",
  "/commercial/power-distribution",
  // Industrial
  "/industrial/600v-800a-services",
  "/industrial/machinery-connections",
  "/industrial/transformer-motor-control",
  "/industrial/plc-automation-wiring",
];

export const isLandingRoute = (pathname: string) =>
  LANDING_ROUTES.some((r) => pathname === r || pathname === `${r}/`);

const SiteHeader = () => {
  const { pathname } = useLocation();
  return isLandingRoute(pathname) ? <LandingHeader /> : <Header />;
};

export default SiteHeader;
